// extracted by mini-css-extract-plugin
export var bgGradientPpc = "index-module--bg-gradient-ppc--80673";